/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { CotizadorContext } from '../context';
import useCarsData from './useCarsData';
import useRentTimeData from './useRentTimeData';
import useExtrasData from './useExtrasData';
import useConfigData from './useConfigData';
import useDeliveryData from './useDeliveryData';

const useTotalData = () => {
    const [state, setState] = useContext(CotizadorContext)
    const { getSelectedCar } = useCarsData();
    const { unit, amount, getSelectedDiscount } = useRentTimeData();
    const { delivery } = useDeliveryData();
    const { getConfigItem } = useConfigData();
    const { selectedExtras, getExtraItem } = useExtrasData();
    const { discount_percentage } = getSelectedDiscount();

    const getCarTotal = (car = null) => {
        const selectedCar = car ? car : getSelectedCar();
        if (selectedCar) {
            if (unit === 'horas') {
                if (amount < selectedCar.min_hours_for_daily_rate) {
                    return selectedCar.hourly_rate * amount;
                } else {
                    return selectedCar.daily_rate;    
                }
                
            } else if (unit === 'dias') {
                return selectedCar.daily_rate * amount;
            }
        }

        return 0;
    }

    const getDeliveryTotal = () => {
        if (delivery.method === 'Servicio puerta a puerta') {
            if (delivery.distance === '20kmplus') {
                return 0
            } else {
                const precioBase = delivery.distance === '10km' ? parseInt(getConfigItem('pap_10k')) : parseInt(getConfigItem('pap_20k'))
                const precio = delivery.subMethod === 'ida y vuelta' ? precioBase * 2 : precioBase;
                return precio;
            }
        }

        return 0;
    }

    const getExtrasTotal = () => {
        let extrasTotal = 0;
        selectedExtras.forEach(id => {
            extrasTotal += parseInt(getExtraSubtotal(id));
        })
        return extrasTotal;
    }

    const getExtraSubtotal = id => {
        const extra = getExtraItem(id);

        if (extra.is_service) {
            return extra.price;
        } else {
            if (unit === 'dias') {
                return extra.price * amount;
            } else {
                return extra.price;
            }
        }
    }

    const getTotalDiscount = () => {
        let totalDiscount = 0
        if(unit === 'dias' && amount) {
            totalDiscount = (getCarTotal() * discount_percentage) / 100;
        }
        return totalDiscount;
    }

    const getTotal = () => {
        return (getCarTotal() - getTotalDiscount()) + getExtrasTotal() /* + getDeliveryTotal() */;
    }

    return {
        getCarTotal,
        getExtraSubtotal,
        getDeliveryTotal,
        getTotal,
        getTotalDiscount
    };
}

export default useTotalData;